const LeftSide = ()=> {
    return (
        <div  id="leftside" className="w-full h-full flex flex-col items-center justify-end gap-6 text-lightestslate">


            <a href="https://github.com/saicharan-myla" className="hover:text-green transition ease-in-out delay-150 hover:scale-100 duration-300">
               
                <i className="fab fa-github"></i>
            </a>

            <a href="https://www.linkedin.com/in/saicharanreddymyla/" className="hover:text-green transition ease-in-out delay-150  hover:scale-100 duration-300">
               
            <i className="fa-brands fa-linkedin-in"></i>
           </a>


            <span className="w-[2px] h-32 bg-slate inline-flex">
        </span>




        </div>
    )
}

export default LeftSide;